import React from 'react';
import { ImmutableRootState } from '@uncinc/react-drupal-core/types';
import { useSelector } from 'react-redux';
import { DEFAULT_LANGUAGE } from '../config/constants';
import { fetchCrisisAlerts } from '../store/actions/UI';
import useTypedDispatch from './useTypedDispatch';

export default function useCrisisAlerts() {
  const dispatch = useTypedDispatch();

  const currentLanguage = useSelector<
  ImmutableRootState<string>, string>(
    (state) => state.getIn(['ui', 'language'], DEFAULT_LANGUAGE),
  );

  React.useEffect(() => {
    dispatch(fetchCrisisAlerts()).catch(console.error);
  }, [currentLanguage, dispatch]);
}
